<template lang="pug">
div
  h2.mb-S Resend e-mail
  BriqRadio(:options="emailTypeOptions" horizontal v-model="mailType" :disabled="isPending")
  BriqInput.mb-S(label="E-mail address" :value="customerEmail" disabled hide-optional-marker)
  BriqInput.mb-S(label="CC" v-model="cc" :disabled="isPending" @blur="$v.cc.$touch()" :error="ccError" data-test-id="send-email-cc-field")
  .actions
    BriqButton.mr-XXS(variant="text" @click="close") Cancel
    BriqButton.ml-XXS(@click="clickSend" :disabled="isPending || !mailType") Send e-mail
</template>

<script>
import { email } from 'vuelidate/lib/validators'
import { MailType } from '@v/bookings/details/BookingDetailsApiModel.js'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ResendMailDialog',
  props: {
    booking: Object
  },
  data() {
    return {
      emailTypeOptions: {
        [MailType.Confirm]: 'Confirmation mail',
        [MailType.Paid]: 'Proof of payment',
      },
      mailType: MailType.Confirm,
      cc: null,
    }
  },
  validations() {
    return {
      cc: { email },
    }
  },
  computed: {
    ...mapGetters('bookingDetails', ['isPending', 'mainBooker']),
    customerEmail() {
      return this.mainBooker?.Email
    },
    ccError() {
      return (this.$v.$dirty && this.$v.cc.$invalid && 'CC needs to be valid email') || null
    },
  },
  methods: {
    ...mapActions('bookingDetails', ['sendEmail']),
    async clickSend() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$notifyWarning('Validation failed, please doublecheck all fields')
        return
      }

      this.loading = true

      const body = {
        BookingKey: this.booking.Key,
        MailType: this.mailType,
        AdditionalRecipients: this.cc ? [this.cc] : null,
      }

      const success = await this.sendEmail(body)
      if (success) {
        this.$notifySuccess(`Email for booking ${this.booking.Number} has been sent.`)
        setTimeout(() => {
          this.loading = false
          this.close()
        }, 2000)
      } else {
        this.$notifyError('Unable to send emails, please try again later.')
        this.loading = false
      }
    },
    close() {
      this.$emit('close')
    }
  },
  watch: {
    showEmailDialog(newVal) {
      if (!newVal) {
        this.cc = null
        this.mailType = null
      } else {
        this.mailType = MailType.Confirm
      }
    },
  },
}
</script>

<style scoped lang="stylus">
.actions
  display: flex;
  justify-content: center;
  align-content: center;
  margin-top: 12px;
</style>
